import Icon from 'semantic-ui-react/dist/commonjs/elements/Icon'
export default Icon
